export enum LocationPrivacyOptionsEnum {
    Public = 'f35fd982-91d7-4160-9aad-bd9b38b7a612',
    OnlyPals = '7c0d2b92-852c-4fe6-b71b-9c52f7f42831',
    OnlyMe = 'bbb0f70a-331a-4e37-89ca-77287e5d244c',
}
